import { Component, OnInit } from '@angular/core';
import { User } from '../../_models/user';
import { AlertService } from '../../_services/alert.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Globals } from '../../_models/globals';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-tool-cost-estimation',
  templateUrl: './tool-cost-estimation.component.html',
  styleUrls: ['./tool-cost-estimation.component.scss'],
})
export class ToolCostEstimationComponent implements OnInit {

  pickUpPinCode: string;
  orderValue: string;
  valueError : string;
  cod = 'N';
  pickUpPinCodeError: string;
  length: string;
  lengthError: string;
  width: string;
  widthError: string;
  height: string;
  heightError: string;
  weight: string;
  weightError: string;
  deliveryPinCode: string;
  deliveryPinCodeError: string;
  costEstimateList: any;
  costEstimation: any;
  paymentMethod: boolean;
  paymentType: string;
  dropdownSettings: IDropdownSettings = {};
  carriers: any = [];
  constructor(private g: Globals, private http: HttpClient, private alertService: AlertService, public user: User) {


  }

  typePickUpPinCode() {
    this.pickUpPinCodeError = "";
    if (!this.pickUpPinCode) {
      this.pickUpPinCodeError = 'Please enter pickup pincode';
    }
  }

  typeLength() {
    this.lengthError = "";
    if (!this.length) {
      this.lengthError = 'Please enter length';
    }
  }

  typeWidth() {
    this.widthError = "";
    if (!this.width) {
      this.widthError = 'Please enter width';
    }
  }

  typeHeight() {
    this.heightError = "";
    if (!this.height) {
      this.heightError = 'Please enter height';
    }
  }

  typeDeliveryPinCode() {
    this.deliveryPinCodeError = "";
    if (!this.deliveryPinCode) {
      this.deliveryPinCodeError = 'Please enter delivery pincode';
    }
  }

  typeWeight() {
    if (!this.weight) {
      this.weightError = 'Please enter weight';
    }
  }



  ngOnInit() {

  }

  submitCostEstimation() {
    if (this.paymentMethod === true) {
      this.paymentType = 'COD';
    } else {
      this.paymentType = 'Prepaid';
    }
    this.pickUpPinCodeError = "";
    this.lengthError = "";
    this.widthError = "";
    this.heightError = "";
    this.weightError = "";
    this.deliveryPinCodeError = "";

    if (!this.pickUpPinCode) {
      this.pickUpPinCodeError = 'Please enter pickup pincode';
    }
    if (!this.length) {
      this.lengthError = 'Please enter length';
    }
    if (!this.width) {
      this.widthError = 'Please enter width';
    }
    if (!this.height) {
      this.heightError = 'Please enter height';
    }
    if (!this.weight) {
      this.weightError = 'Please enter weight';
    }
    if (!this.deliveryPinCode) {
      this.deliveryPinCodeError = 'Please enter delivery pincode';
    }
    if (this.cod == 'N') {
            this.valueError = ""
            }
            if(this.cod == 'Y' && !this.orderValue){
            this.valueError = "Please enter the COD amount"
            }


    if (this.pickUpPinCodeError != '' || this.lengthError != '' || this.widthError != '' || this.heightError != '' || this.weightError != '' || this.deliveryPinCodeError != '' || this.valueError!='' ) {
      return false;
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    this.g.loaderDisplay = "display";
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/costEstimationForShiftAggregator', {
      "breadth": this.width,
      "destPincode": this.deliveryPinCode,
      "height": this.height,
      "length": this.length,
      "orderType": "PICK",
      "organizationId": this.user.organizationId,
      "originPincode": this.pickUpPinCode,
      "paymentMethod": this.paymentType,
      "weight": this.weight,
      "preferenceOnly": "N",
      //."carrierCode": this.carriers.join(',')
      "carrierName": this.carriers,
      "orderValue" : this.orderValue || null,

    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.costEstimateList = data;
          this.costEstimation = this.costEstimateList.costEstimateList;
          this.alertService.success('Cost Estimation', 'Submitted successfully');
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });

  }

  typeValue(){
   this.valueError = '';
   if(this.orderValue == null || this.orderValue == undefined || this.orderValue == ""){
    this.valueError = "Please enter the COD amount";
   }}


   onClick(){
   if(this.cod == 'N'){
       this.cod = 'Y';
       this.orderValue = '';
       } else if(this.cod == 'Y'){
       this.cod = 'N';
       this.orderValue = '';
       }
   }

}
